import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Configuration } from '../models/configuration.model';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private endpointPrefix = '';
  configData!: Configuration;

  constructor(private http: HttpClient) {}

  setEndpointPrefix(endpointPrefix: string): void {
    this.endpointPrefix = endpointPrefix;
  }

  getEndpointFor(api: string, microservice?: string): string {
    if (microservice) {
      return `${this.endpointPrefix}services/${microservice}/${api}`;
    }
    return `${this.endpointPrefix}${api}`;
  }

  getConf(): Promise<Configuration> {
    return this.http
      .get<Configuration>('configuration.json')
      .pipe(
        tap(result => {
          this.configData = result;
        })
      )
      .toPromise();
  }
}
